import React, { useEffect, useState } from 'react';
import axios from 'axios';
import AddressBook from './AddressBook';
import {
  getPunditPurohitAuthHeaders,
  getStoredPunditPurohitUser,
  setStoredPunditPurohitUser,
} from '../utils/auth';
import SubscriptionModal from '../components/SubscriptionModal';

const Profile = () => {
  const [profile, setProfile] = useState(null);
  const [form, setForm] = useState({ firstName: '', lastName: '', mobile: '', password: '' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [showSubscription, setShowSubscription] = useState(false);
  const [subscriptionFlowEnabled, setSubscriptionFlowEnabled] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const apiBase = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    axios
      .get(`${apiBase}/api/punditpurohit/profile`, { headers: getPunditPurohitAuthHeaders() })
      .then((res) => {
        setProfile(res.data);
        setForm({
          firstName: res.data.first_name || '',
          lastName: res.data.last_name || '',
          mobile: res.data.mobile || '',
          password: '',
        });
      })
      .catch((err) => setError(err?.response?.data?.message || 'Unable to load profile.'))
      .finally(() => setLoading(false));

    axios
      .get(`${apiBase}/api/punditpurohit/checkout-settings`)
      .then((res) => setSubscriptionFlowEnabled(Boolean(res.data?.subscriptionFlowEnabled)))
      .catch((err) => {
        console.error('Unable to load subscription settings', err);
        setSubscriptionFlowEnabled(false);
      });
  }, [apiBase]);

  const handleSave = (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    setMessage('');

    axios
      .put(`${apiBase}/api/punditpurohit/profile`, form, { headers: getPunditPurohitAuthHeaders() })
      .then(() => {
        const updatedUser = {
          ...(getStoredPunditPurohitUser() || {}),
          name: `${form.firstName} ${form.lastName}`.trim(),
          mobile: form.mobile,
        };
        setStoredPunditPurohitUser(updatedUser);
        setMessage('Profile updated.');
      })
      .catch((err) => setError(err?.response?.data?.message || 'Unable to update profile.'))
      .finally(() => setSaving(false));
  };

  if (loading) return <div className="pp-account-page">Loading profile...</div>;

  return (
    <div className="pp-account-page">
      {subscriptionFlowEnabled && (
        <SubscriptionModal
          open={showSubscription}
          onClose={() => setShowSubscription(false)}
          title="Manage your annual subscription"
        />
      )}
      <section className="pp-profile-panel">
        <div>
          <h2>Your Profile</h2>
          {profile?.punditApprovalStatus && (
            <span className={`pp-status-chip ${profile.isPundit ? 'approved' : ''}`}>
              Pundit: {profile.punditApprovalStatus.replace('_', ' ')}
            </span>
          )}
        </div>

        <form onSubmit={handleSave} className="pp-profile-form">
          <div className="form-row">
            <div className="input-group">
              <label>First Name</label>
              <input
                required
                value={form.firstName}
                onChange={(e) => setForm({ ...form, firstName: e.target.value })}
              />
            </div>
            <div className="input-group">
              <label>Last Name</label>
              <input
                required
                value={form.lastName}
                onChange={(e) => setForm({ ...form, lastName: e.target.value })}
              />
            </div>
          </div>
          <div className="input-group">
            <label>Mobile Number</label>
            <input
              required
              value={form.mobile}
              onChange={(e) => setForm({ ...form, mobile: e.target.value })}
            />
          </div>
          {profile?.source === 'pundit_purohit' && (
            <div className="input-group">
              <label>New Password</label>
              <input
                type="password"
                minLength="6"
                placeholder="Leave blank to keep current password"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
              />
            </div>
          )}
          {message && <div className="auth-alert auth-alert-success">{message}</div>}
          {error && <div className="auth-alert auth-alert-error">{error}</div>}
          <button type="submit" className="login-submit-btn" disabled={saving}>
            {saving ? 'Saving...' : 'Save Profile'}
          </button>
        </form>
      </section>

      {subscriptionFlowEnabled && (
        <section className="pp-profile-panel pp-subscription-manage-panel">
          <div>
            <h2>Annual Subscription</h2>
            <p>Manage your pooja plan and switch to a higher tier when you need more monthly benefits.</p>
          </div>
          <button type="button" className="login-submit-btn" onClick={() => setShowSubscription(true)}>
            Manage Subscription
          </button>
        </section>
      )}

      <AddressBook embedded />
    </div>
  );
};

export default Profile;
